<script>
export default {
  name: "DateSelect",
  // props: {
  // dateRange: {
  //   default() {
  //     return [];
  //   },
  //   type: Array
  // }
  // },
  data() {
    return {
      dateRange: [new Date().getTime() - 1000 * 3600 * 24 * 7, new Date().getTime()],
      pickerOptions: {
        shortcuts: [
          {
            text: '近12小时',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 43200000);
              this.daterange = [start, end];
              picker.$emit('pick', this.daterange);
            }
          },
          {
            text: '昨天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();

              start.setDate(start.getDate() - 1)
              start.setHours(0);
              start.setMinutes(0);
              start.setSeconds(0);
              end.setHours(0);
              end.setMinutes(0);
              end.setSeconds(0);
              this.daterange = [start, end];
              picker.$emit('pick', this.daterange);
            }
          },
          {
            text: '近7天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              this.daterange = [start, end];
              picker.$emit('pick', this.daterange);
            }
          },
          {
            text: '近15天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 15);
              this.daterange = [start, end];
              picker.$emit('pick', this.daterange);
            }
          },
          {
            text: '近30天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              this.daterange = [start, end];
              picker.$emit('pick', this.daterange);
            }
          },
        ],
        onPick: ({maxDate, minDate}) => {

        },
        disabledDate:
            (time) => {
              return time.getTime() > Date.now();
            }
      }
    }
  },
  methods: {
    onSubmit() {
      this.$emit('pick', this.dateRange);
    }
  }
}
</script>

<template>
  <el-date-picker
      ref="picker"
      style="width: 250px"
      v-model="dateRange"
      :picker-options="pickerOptions"
      value-format="timestamp"
      type="daterange"
      range-separator="-"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      @change="onSubmit"
  >
  </el-date-picker>
</template>

<style scoped lang="scss">

</style>